<!-- 财经热点 -->
<template>
  <div class="container">
    <banner></banner>
    <div class="mynews">
    <!-- 导航栏 -->
    <div class="newsMenu">
      <div class="newsMenu-1">
        <!-- <ul class="newsMenu-nav">
          <li v-for="route in routes" :key="route.name">
            <router-link :to="route.path" :class="{ active: currentRoute === route.name }">
              {{ route.name }}
            </router-link>
          </li>
        </ul> -->
        <ul class="newsMenu-nav">
          <a   href="/news"><li class="a-bg">最新</li></a>
          <a  href="/popular"><li>热门</li></a>
          <a  href="/flash"><li>快讯</li></a>
          <a  href="/important"><li>要闻</li></a>
        </ul>
      </div>
      <div class="search-with-logo">
        <input class="search" type="text" name="news" v-model="searchQuery" @input="change()" placeholder="请输入关键词搜索">
        <img class="search-logo" src="../../assets/search.jpg" alt="search" @click="performSearch">
    </div>
    </div>


    <!-- 新闻 -->
    <div class="newsbody">
      <div class="View-body1">
        <v-card v-for="news1 in NewsInfo" :key="news1.uniquekey" class="news-card">
          <v-card-actions>
          <!-- <v-btn text @click="readMore(news.url)"> -->
            <router-link :to="{ name: 'newsText', params: { id: news1.id }}">
            <div class="pp">
            <div class="news-list">
              <div v-if="news1.image" >
                <img class="news-img" :src="news1.image" alt="">
              </div>
              <!-- <div class="pp-tt"> -->
                <div 
                :key="index"
                :class="news1.image?'pp-tt':'pp-tt1'"
                >
                <div class="pp-title">
                  <v-card-title v-html="news1.title"></v-card-title>
                </div>
                <div class="pp-text">
                  <v-card-text v-html="news1.content"></v-card-text>
                </div>
                <div class="pp-bo">
                  <div class="pp-bo1">
                    <p class="pp-bo1-text">最新</p>
                  </div>
                  <div class="pp-bo2">
                        <div><v-card-subtitle v-text="news1.user.username"></v-card-subtitle></div>
                        <div><p>发布于</p></div>
                        <div><v-card-subtitle v-text="news1.time_since_create"></v-card-subtitle></div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </router-link>
      <!-- </v-btn> -->
        </v-card-actions>
        </v-card>
        

        
      </div>

      <!-- 实时热榜 -->
      <div class="body2">
        <p class="newsTitle">实时热榜</p>
        <div class="list-span">
          <div v-for="(news,index) in News.slice(0,limit)" :key="index" >
              <v-card-actions class="list-text">
                <router-link :to="{ name: 'newsText', params: { id: news.id }}" >
                  <div class="list-text">
                    <span
                    :key="index"
                    :class="index<3?'number1':'number2'"
                    >{{ index+1 }}</span>

                    <span v-if="news.title"
                    :class="pp-hotlist"
                    >
                    <v-card-text v-html="news.title"></v-card-text>
                    </span>
                </div>
                </router-link>
              </v-card-actions>
          </div>
        </div>
        
        
      </div>
    </div>
  </div>
    
  </div>

  
</template>
    
    
<script >
import {
  getDetailById,
  getNews
} from "@/api/api";
  import banner from '@/views/layout/components/banner.vue'
  export default {
    props:['id'],
    components: {banner},
    data() {
      return { 
        currentRoute: this.$route.name,
        routes: [
          { path: '/news', name: '最新' },
          { path: '/popular', name: '热门' },
          { path: '/flash', name: '快讯' },
          { path: '/important', name: '要闻' }
        ],
        test:"",
        searchQuery:"",
        highlightedContent:"",
        originalNews: [],
        
        News: "",
        hot_news:"",
        limit:9,

      NewsInfo: "",
      // loading: false,
      // error: "",
          };
        },
    computed: {
    },
    watch: {
      '$route' (to, from) {
        this.currentRoute = to.name;
      }
    },
    methods: {
      // change(){
      //   console.log(this.searchQuery)
      // },
      change() {
        if (this.searchQuery.trim() === '') {
          // 输入框为空，显示原始新闻列表
          this.NewsInfo = [...this.originalNews];
        } else {
          // 输入框不为空，执行搜索逻辑
          this.performSearch();
        }
      },
      refreshPage() {
        // 刷新页面
        window.location.reload(true);
      },
      readMore(url) {
        window.open(url,'_blank');
      },

      // async getComplain(){
      //   const res=await getcomplaint();
      //   this.test=res;
      //   console.log(this.test)
      // },
      
      async fetchNewsInfo() {
          const res= await getNews(); 
          this.NewsInfo = res.results.map(news1 => ({
          id: news1.id,
          title: news1.title,
          content: news1.content,
          // created_at: news1.created_at,
          picture:news1.image,
          user: {
            id: news1.user.id,
            username:news1.user.username,
          },
          time_since_created: news1.time_since_created
        }));
      },

      async getInfo(){
        const res = await getNews()
        this.originalNews = res.results.map(news => ({
          id: news.id,
          title: news.title,
            content: news.content,
            // created_at: news.created_at,
            picture:news.image,
            user: {
              id: news.user.id,
              username:news.user.username,
            },
            time_since_create:news.time_since_create,
        }));
        this.News=[...this.originalNews];
        console.log(this.News);
      },

      // 搜索
      performSearch() {
        if (this.searchQuery.trim() === '') {
          // 输入框为空，显示原始新闻列表
          this.NewsInfo = [...this.originalNews];
        } else {
          // 执行搜索并高亮显示结果
          const query = this.searchQuery.trim();
          const regex = new RegExp(query, 'gi');
          this.NewsInfo = this.originalNews.filter(news => {
            // 检查标题或内容是否包含搜索词
            return regex.test(news.title) || regex.test(news.content);
          }).map(news => {
            // 高亮显示标题和内容
            const highlightedTitle = news.title.replace(regex, '<span class="highlight">$&</span>');
            const highlightedContent = news.content.replace(regex, '<span class="highlight">$&</span>');
            return {
              ...news,
              title: highlightedTitle,
              content: highlightedContent
            };
          });
        }
      },
      highlightText(newsArray, query) {
        if (!query) {
          // 如果查询为空，重置为原始新闻列表
          this.NewsInfo = [...this.originalNews];
        } else {
          // 构建正则表达式，用于搜索和高亮显示
          const regex = new RegExp(`(${query})`, 'gi');
          // 映射新闻数组，对每个新闻项进行处理
          this.highlightedContent = newsArray.map(news => {
            // 检查标题或内容是否包含搜索词，并进行高亮显示
            const highlightedTitle = news.title.replace(regex, '<span class="highlight">$1</span>');
            const highlightedContent = news.content.replace(regex, '<span class="highlight">$1</span>');
            return {
              ...news,
              title: regex.test(news.title) ? highlightedTitle : news.title, // 仅当标题包含搜索词时高亮显示
              content: regex.test(news.content) ? highlightedContent : news.content // 仅当内容包含搜索词时高亮显示
            };
          });
          // 更新新闻列表为高亮后的新闻列表
          this.NewsInfo = this.highlightedContent;
        }
      },
      formatTitle(title) {
        if (!title) return '';
        return title.length > 20 ? title.slice(0, 20) + '...' : title;
      }
  },
  created  () {
    this.fetchNewsInfo();
    // this.getComplain();
   },
  mounted  () {
    this.getInfo().then( ()=>{
      // console.log('数据获取成功',this.company_news);
    }).catch(error => {
        // 处理错误
        console.error('Error fetching data: ', error);
      });
    this.getInfo().then(() => {
      // 设置News为originalNews的副本
      this.NewsInfo = [...this.originalNews];
    }).catch(error => {
      console.error('Error fetching data: ', error);
    });
  },
};
  

  </script>
    <style lang='scss' scoped>
    @import "../news/style/news.css";
    .news-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    </style>